export const state = {
  projects: [
    {
      title: "Unraid",
      url: "https://unraid.net/",
      tags: ["Craft CMS 3", "Craft Commerce 2", "Front-end", "DevOps"]
    },
    {
      title: "Soon to be released app + more for Unraid",
      tags: ["Serverless", "GraphQL", "Vue.js SPA", "DevOps"]
    },
    {
      title: "sabukaru.online 東京",
      url: "https://sabukaru.online/",
      tags: ["Concept", "Design", "SquareSpace"]
    },
    {
      title: "Santa Cruz Museum of Art & History",
      url: "https://santacruzmah.org/",
      tags: ["Craft CMS 3", "Multilingual", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "DAS42",
      url: "https://das42.com/",
      tags: ["Craft CMS 3", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "YoungArts Post",
      url: "https://youngartspost.org/",
      tags: ["Vue.js", "DevOps"],
      attribution: true
    },
    {
      title: "City of Santa Cruz Economic Development",
      url: "https://choosesantacruz.com/",
      tags: ["Craft CMS 2", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Santa Cruz Fiber",
      url: "https://santacruzfiber.com/",
      tags: ["Craft CMS 2", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Digital Control (DCI)",
      url: "https://digital-control.com/",
      tags: ["Craft CMS", "Multilingual", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "HeliTrak",
      url: "https://helitrak.com/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Romero Institute",
      url: "https://romeroinstitute.org/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "SnapRoute",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "Front & Cooper",
      url: "https://frontandcooper.com/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Community Foundation for San Benito County",
      url: "https://givesanbenito.org/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Element Analytics",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "Mount Madonna Center",
      url: "https://www.mountmadonna.org/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Mount Madonna Institute",
      url: "https://www.mountmadonnainstitute.org/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "The Renewal Workshop",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "Nextspace Coworking",
      tags: ["Craft CMS", "Front-end", "E-commerce", "DevOps"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "P.J. Selzer",
      url: "http://pjselzer.com/",
      tags: ["Craft CMS", "Front-end", "E-commerce", "DevOps"],
      attribution: false
    },
    {
      title: "Greek Orthodox Metropolis of SF",
      url: "http://sanfran.goarch.org/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Stanford Research Park",
      url: "http://stanfordresearchpark.com/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "ICIX",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "HWVP",
      url: "http://hwvp.com/",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "The Mill",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Imergy",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Ampush",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "Santa Cruz Film Fest",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "Design by Cosmic, Inc.",
      tags: ["Craft CMS 2 & 3", "Front-end", "DevOps"],
      attribution: true,
      attributionText: "three versions for Cosmic"
    },
    {
      title: "Turbo Trimmerz",
      tags: ["Craft CMS", "Front-end", "DevOps"],
      attribution: true
    },
    {
      title: "Tango",
      tags: ["Craft CMS", "Multilingual", "Front-end"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "The Go Game",
      tags: ["Front-end"],
      attribution: true,
      attributionText: "prev version for Cosmic"
    },
    {
      title: "Hugs 'n Kitchen",
      tags: ["WordPress", "Front-end", "DevOps"]
    }
  ]
};
